import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import SensorHandle from '../SensorHandle';
import { SensorButtonNodeType } from '../types';
import BaseNode from '../BaseNode';

export const SensorButtonNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: SensorButtonNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    const { buttons, language } = data.options;
    return (
      <BaseNode
        selected={selected ?? false}
        type="sensor"
        isValid={data.isValid}
        disabled={disabled ?? false}
        testId="sensor-button-node"
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Button',
              id: 'KP63fg',
            })}
          </T>
          <T body2>
            {buttons && buttons.length > 0
              ? `${buttons.length === 1 ? buttons[0].name : 'Buttons'} | ${
                  language ??
                  intl.formatMessage({
                    defaultMessage: 'Any',
                    id: 'ToO3/h',
                  })
                }`
              : 'Name'}
          </T>
        </Flex>
        <SensorHandle id="active" disabled={disabled} />
      </BaseNode>
    );
  },
);
